/* unplugin-vue-components disabled */import { render } from "./projectdetail.vue?vue&type=template&id=6e9ddac2"
import script from "./projectdetail.vue?vue&type=script&lang=js"
export * from "./projectdetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__